import CryptoJS from "crypto-js";
import React, { useState, useEffect, useRef } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import { useFetchCustomerUseListDataQuery, useFetchEditTaskQuery } from "../../utils/customer/customerSelect";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { saveTasks, hideMessage } from "../../utils/customer/customerTaskSlice";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomerEditTaskActivity from "./CustomerEditTaskActivity";
import SearchableInput from "./SearchableInput";
import useCustomFormValidation from "../../hooks/ErrorHandling/useCustomFormValidation";
import { useFetchEnumFieldGetApiQuery } from "../../utils/enumApi";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";

import { RadioGroup, FormControlLabel, Radio, FormControl, FormLabel } from "@mui/material";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import RecurrenceSection from "./RecurrenceSection";
import { ReactComponent as CalendarIcon } from "../../assets/images/calendarIcon.svg";

const validationRules = {
  daily_interval: { required: true, number: true, errorMessage: "Enter a valid number for daily interval." },
  weekly_interval: { required: true, number: true, errorMessage: "Enter a valid number for weekly interval." },
  monthly_day: { required: true, number: true, errorMessage: "Enter a valid day for monthly interval." },
  monthly_interval: { required: true, number: true, errorMessage: "Enter a valid interval for monthly recurrence." },
  frequency: { required: true, errorMessage: "Please select a recurrence pattern." },
  recurr_pattern_times: { required: true, number: true, errorMessage: "Enter a valid number for pattern times." },
  recurr_pattern_days: { required: true, errorMessage: "Please select days of the week." },
};

const RecurrenceModal = ({
  ActivateRecur,
  closePopup,
  taskid,
  handelSubmitData,
  setStartDate,
  startDate,
  setEndDate,
  endDate,
  StartTime,
  EndTime,
  formData,
  setFormData,
  open,
  drawerRef,
  // parallelDrawer,
  subDrawer,
}) => {
  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const monthOfYear = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const formRef = useRef(null);
  const hideArrowClass =
    "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none";

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const handleStartDateChange = (date) => {
    setStartDate(date);

    if (endDate && date >= endDate) {
      const nextDay = new Date(date);
      nextDay.setDate(nextDay.getDate() + 1);
      setEndDate(nextDay);
    }
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  // const [formData, setFormData] = useState({
  //   frequency: taskid?.frequency || "daily",
  //   intervals:  taskid?.intervals || "",
  //   every_weeks: "",
  //   daily_recur: "",
  //   monthly_recur: "",
  //   yearly_recur: "",
  //   occurrences: "",
  //   daily_option:  taskid?.daily_option || 'every_n_days',
  //   weekly_days: initialWeeklyDays,
  //   endBy: 'end_by',
  //   monthly_option: taskid?.monthly_option || 'specific_day',
  //   monthly_week:  taskid?.monthly_week	 || 'first',
  //   day_of_week: taskid?.day_of_week,
  //   day_of_month:  taskid?.day_of_month,
  //   yearly_option:  taskid?.yearly_option || 'specific_year',
  // });

  const calculateEndDate = (startDate, intervals, occurrences) => {
    const newEndDate = new Date(startDate);
    newEndDate.setDate(newEndDate.getDate() + intervals * occurrences);
    return newEndDate;
  };

  const { values, errors, touched, handleChange, handleBlur, isFormValid } = useCustomFormValidation(
    formData,
    validationRules
  );

  const handleFieldChange = (e) => {
    handleChange(e);
    const { name, value } = e.target;

    if (value === "") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: "",
      }));
      return;
    }

    if (name === "day_of_month" && (value < 1 || value > 31)) return;
    if (name === "intervals" && (value < 1 || value > 52)) return;
    if (name === "occurrences" && (value < 1 || value > 1000)) return;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  // const {
  //   data: companyCommnData,
  //   error,
  //   isLoading,
  // } = useFetchEnumFieldGetApiQuery({token,table_name: "recurrence_patterns" });

  // useEffect(() => {
  //   if(token){
  //     fetchOptions('your_table_name', 'your_column_name');
  //   }
  // }, [token]);

  // const handleRecurrenceChange = (event) => {
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     radioselected: {
  //       ...prevFormData.radioselected,
  //       daily_option: event.target.value
  //     }
  //   }));
  // };

  const handleEndByChange = (event) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      endBy: event.target.value,
    }));
  };

  const toggleDaySelection = (day) => {
    setFormData((prevFormData) => {
      const { weekly_days } = prevFormData;
      const isSelected = weekly_days.includes(day);

      return {
        ...prevFormData,
        weekly_days: isSelected ? weekly_days.filter((d) => d !== day) : [...weekly_days, day],
      };
    });
  };

  console.log(formData?.weekly_days, "formData days new");

  const handleRecurTask = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // setFormData(prevFormData => ({
    //   ...prevFormData,
    //   selection: "entire"
    // }));
    // const validationErrors = validateForm();

    // if (isFormValid()) {
    // ActivateRecur(formData);

    // }

    // if(formData?.recurr_pattern === "daily"){
    //   if(formData?.radioselected?.recurrence === "every"){
    //       if(formData?.every_day === ''){
    //              return;
    //       }

    //   }
    // }

    // ActivateRecur(formData);
    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        selection: "entire",
        is_recurrence: 1,
      };

      ActivateRecur(updatedFormData);

      return updatedFormData;
    });
  };

  // const handleSubmitTask = async (event) => {
  //   event.preventDefault();

  //   if (
  //     !validateForm() ||
  //     !selectedItem ||
  //     !selectedItem.id ||
  //     !event.target.task_pod.value ||
  //     !event.target.subject.value ||
  //     !event.target.category_id.value ||
  //     !startDate ||
  //     !endDate
  //   ) {
  //     if (!selectedItem || !selectedItem.id) setOwnerError("Owner is required");
  //     console.log("Form has errors");
  //     return false;
  //   }

  //   const taskData = {
  //     subject: event.target.subject.value,
  //     category_id: event.target.category_id.value,
  //     priority: event.target.priority.value,
  //     task_pod: event.target.task_pod.value,
  //     start_date: startDate,
  //     end_date: endDate,
  //     customer_id: customerId,
  //     company_id: parsedCompanyData.company_id,
  //     description: event.target.description.value,
  //     owner: selectedItem,
  //     contact_name: event.target.contact_name.value,
  //     status: event.target.status.value,
  //   };
  //   try {
  //     await dispatch(saveTasks({ taskData, token }));
  //     await handelSubmitData(customerId);
  //     closePopup();
  //     event.target.reset();
  //   } catch (error) {}
  // };

  useEffect(() => {
    // Validate startDate first
    if (!startDate || isNaN(new Date(startDate).getTime())) {
      console.error("Invalid startDate provided");
      return;
    }

    // Convert inputs to numbers and fallback to 0 if they are not valid
    const intervals = parseInt(formData.intervals, 10);
    const validIntervals = isNaN(intervals) ? 1 : intervals;

    const occurrences = parseInt(formData.occurrences, 10);
    const validOccurrences = isNaN(occurrences) ? 1 : occurrences;

    let totalDays = 0;
    let futureDate = new Date(startDate);

    if (formData?.frequency === "daily") {
      if (formData?.daily_option === "every_weekday") {
        totalDays = 7 * validOccurrences;
      } else {
        totalDays = validIntervals * validOccurrences;
      }
      futureDate.setDate(futureDate.getDate() + totalDays);
    } else if (formData?.frequency === "weekly") {
      totalDays = validIntervals * 7 * validOccurrences;
      futureDate.setDate(futureDate.getDate() + totalDays);
    } else if (formData?.frequency === "monthly") {
      // For monthly, add months properly
      const monthsToAdd = validIntervals;
      const startDateObj = new Date(startDate);
      const day = formData?.day_of_month || startDateObj.getDate();

      // Create target date based on month addition

      let targetDate = new Date(
        startDateObj.getFullYear(),
        startDateObj.getMonth() + monthsToAdd * validOccurrences,
        day
      );

      // Check if targetDate's month is as expected
      // const expectedMonth = (startDateObj.getMonth() + monthsToAdd) % 12;
      // if (targetDate.getMonth() !== expectedMonth) {
      //   // Adjust to the last day of the intended month.
      //   targetDate = new Date(
      //     startDateObj.getFullYear(),
      //     startDateObj.getMonth() + monthsToAdd + 1,
      //     0
      //   );
      // }
      futureDate = targetDate;
    }

    setEndDate(futureDate);
  }, [
    formData?.frequency,
    startDate,
    formData?.intervals,
    formData?.occurrences,
    formData?.daily_option,
    formData?.day_of_month,
  ]);

  //   useEffect(() => {
  //   if (formData?.daily_option === "every_weekday" && formData?.frequency === "daily") {
  //     const newEndDate = new Date(startDate);
  //     newEndDate.setDate(newEndDate.getDate() + ( 7*formData.occurrences));
  //     setEndDate(newEndDate);
  //     setFormData({ ...formData, intervals: 1 });
  //   } else if (formData.intervals) {
  //     const newEndDate = calculateEndDate(startDate, formData?.intervals,formData?.occurrences);
  //     setEndDate(newEndDate);
  //   }
  // }, [formData?.intervals, formData?.daily_option, startDate,formData?.occurrences]);

  const daysInMonth = (month) => {
    const days = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return days[month - 1];
  };

  const handleDayValidation = (e) => {
    const value = e.target.value;
    const maxDays = daysInMonth(formData?.intervals);

    if (Number(value) < 1 || Number(value) > maxDays) {
      e.target.value = value.slice(0, -1);
    }
  };

  // const RenderRecurrenceSection = () => {
  //   switch (formData?.frequency) {
  //     case "daily":
  //       return (
  //         <div>
  //           <div className="flex gap-5 py-2 items-center">
  //             <div>
  //               <input
  //                 type="radio"
  //                 name="daily_option"
  //                 value={"every_n_days"}
  //                 className="radio  checked:border-indigo-500 checked:bg-indigo-900"
  //                 checked={formData?.daily_option === "every_n_days"}
  //                 onChange={handleFieldChange}
  //               />
  //             </div>
  //             <div className="text-xs">Every</div>

  //             <div className="appearance-none pb-5 px-3 w-20 h-9 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block">
  //               <input
  //                 type="number"
  //                 id="intervals"
  //                 name="intervals"
  //                 value={formData?.intervals}
  //                 onChange={(e) => {
  //                   const value = e.target.value;
  //                   if ((/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 10000) || value === "") {
  //                     handleFieldChange(e);
  //                   }
  //                 }}
  //                 onBlur={(e) => {
  //                   const value = e.target.value;
  //                   if (!value || Number(value) < 1) {
  //                     handleFieldChange({ target: { name: "intervals", value: "1" } });
  //                   }
  //                 }}
  //                 className={`w-16 p-0 bg-transparent border-0 text-gray-800 focus:ring-0 dark:text-white disabled:opacity-50 disabled:bg-[#EBEBE4]`}
  //                 placeholder=""
  //                 required
  //                 disabled={formData?.daily_option === "every_weekday"}
  //                 min={1}
  //               />
  //             </div>
  //             <div className="text-xs">Day &#40; s &#41;</div>
  //           </div>
  //           <div className="flex items-center gap-5 ">
  //             <div>
  //               <input
  //                 type="radio"
  //                 name="daily_option"
  //                 value={"every_weekday"}
  //                 className="radio  checked:border-indigo-500 checked:bg-indigo-900"
  //                 onChange={handleFieldChange}
  //                 checked={formData?.daily_option === "every_weekday"}
  //               />
  //             </div>
  //             <div className="text-xs">Every Weekdays</div>
  //           </div>
  //         </div>
  //       );
  //     case "weekly":
  //       return (
  //         <div>
  //           <div className="flex items-center gap-5">
  //             <div className="text-xs">
  //               Re<u>c</u>ur every
  //             </div>

  //             <div className="appearance-none pb-5 px-3 w-20 h-9 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block">
  //               <input
  //                 type="number"
  //                 name="intervals"
  //                 value={formData?.intervals}
  //                 onChange={(e) => {
  //                   const value = e.target.value;
  //                   if ((/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 10000) || value === "") {
  //                     handleFieldChange(e);
  //                   }
  //                 }}
  //                 onBlur={(e) => {
  //                   const value = e.target.value;
  //                   if (!value || Number(value) < 1) {
  //                     handleFieldChange({ target: { name: "intervals", value: "1" } });
  //                   }
  //                 }}
  //                 className="w-16 p-0 bg-transparent border-0 text-gray-800 focus:ring-0 dark:text-white"
  //                 min={1}
  //               />
  //             </div>
  //             <div className="items-center text-xs">week(s) on:</div>
  //           </div>

  //           {/*<div className="gap-2 flex flex-grow">
  //             <button
  //               type="button"
  //               id="toggleButton"
  //               className=" text-xs font-normal hover:bg-sky-950 hover:text-white focus:bg-sky-950 focus:text-white items-center p-2 px-4 border rounded"
  //             >
  //               Sun
  //             </button>
  //             <button
  //               type="button"
  //               id="toggleButton"
  //               className=" text-xs font-normal hover:bg-sky-950 hover:text-white focus:bg-sky-950 focus:text-white items-center p-2 px-4 border rounded"
  //             >
  //               Mon
  //             </button>
  //             <button
  //               type="button"
  //               id="toggleButton"
  //               className=" text-xs font-normal hover:bg-sky-950 hover:text-white focus:bg-sky-950 focus:text-white items-center p-2 px-4 border rounded"
  //             >
  //               Tue
  //             </button>
  //             <button
  //               type="button"
  //               id="toggleButton"
  //               className=" text-xs font-normal hover:bg-sky-950 hover:text-white focus:bg-sky-950 focus:text-white items-center p-2 px-4 border rounded"
  //             >
  //               Wed
  //             </button>
  //             <button
  //               type="button"
  //               id="toggleButton"
  //               className=" text-xs font-normal hover:bg-sky-950 hover:text-white focus:bg-sky-950 focus:text-white items-center p-2 px-4 border rounded"
  //             >
  //               Thu
  //             </button>
  //             <button
  //               type="button"
  //               id="toggleButton"
  //               className=" text-xs font-normal hover:bg-sky-950 hover:text-white focus:bg-sky-950 focus:text-white items-center p-2 px-4 border rounded"
  //             >
  //               Fri
  //             </button>
  //             <button
  //               type="button"
  //               id="toggleButton"
  //               className=" text-xs font-normal hover:bg-sky-950 hover:text-white focus:bg-sky-950 focus:text-white items-center p-2 px-4 border rounded"
  //             >
  //               Sat
  //             </button>
  //           </div>
  //           */}

  //           <div className="gap-2 flex flex-grow mt-4">
  //             {daysOfWeek.map((day, index) => (
  //               <button
  //                 key={index}
  //                 type="button"
  //                 className={`text-xs font-normal items-center p-2 px-4 border rounded ${
  //                   formData?.weekly_days?.includes(day)
  //                     ? "bg-sky-950 text-white"
  //                     : "hover:bg-sky-950 hover:text-white focus:bg-sky-950 focus:text-white"
  //                 }`}
  //                 onClick={() => toggleDaySelection(day)}
  //               >
  //                 {day?.slice(0, 3)}
  //               </button>
  //             ))}
  //           </div>
  //         </div>
  //       );
  //     case "monthly":
  //       return (
  //         <div>
  //           <div className="flex gap-2 py-2 items-center">
  //             <div>
  //               <input
  //                 type="radio"
  //                 name="monthly_option"
  //                 value={"specific_day"}
  //                 className="radio  checked:border-indigo-500 checked:bg-indigo-900"
  //                 checked={formData?.monthly_option === "specific_day"}
  //                 onChange={handleFieldChange}
  //               />
  //             </div>
  //             <div className="text-xs">Day</div>

  //             <div className="appearance-none pb-5 px-3 w-16 h-8 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block">
  //               <input
  //                 type="number"
  //                 id="day_of_month"
  //                 name="day_of_month"
  //                 value={formData?.day_of_month}
  //                 onChange={handleFieldChange}
  //                 className="w-full p-0 bg-transparent border-0 text-gray-800 focus:ring-0 dark:text-white"
  //                 placeholder=""
  //                 onKeyUp={handleDayValidation}
  //                 required
  //                 min={1}
  //                 max={31}
  //               />
  //             </div>

  //             <div className="text-xs">Of Every</div>

  //             <div className="appearance-none pb-5 px-3 w-16 h-8 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block">
  //               <input
  //                 type="number"
  //                 id="intervals"
  //                 name="intervals"
  //                 value={formData?.intervals}
  //                 onChange={(e) => {
  //                   const value = e.target.value;
  //                   if ((/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 10000) || value === "") {
  //                     handleFieldChange(e);
  //                   }
  //                 }}
  //                 onBlur={(e) => {
  //                   const value = e.target.value;
  //                   if (!value || Number(value) < 1) {
  //                     handleFieldChange({ target: { name: "intervals", value: "1" } });
  //                   }
  //                 }}
  //                 className="w-full p-0 bg-transparent border-0 text-gray-800 focus:ring-0 dark:text-white"
  //                 placeholder=""
  //                 min={1}
  //                 max={12}
  //                 // onKeyUp={() => { }}
  //                 onKeyUp={(e) => {
  //                   const value = e.target.value;

  //                   if (Number(value) < 1 || Number(value) > 12) {
  //                     e.target.value = value.slice(0, -1);
  //                   }
  //                 }}
  //                 required
  //                 // min={1}
  //               />
  //             </div>

  //             <div className="text-xs">Month &#40; s &#41;</div>
  //           </div>

  //           {/*  */}
  //         </div>
  //       );
  //     case "yearly":
  //       return (
  //         <div>
  //           <div className="flex gap-2 py-2 items-center">
  //             <div className="text-xs">
  //               Re<u>c</u>ur every
  //             </div>

  //             <div className="appearance-none pb-5 px-3 w-20 h-9 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block">
  //               <input
  //                 type="number"
  //                 id="intervals"
  //                 name="intervals"
  //                 value={formData?.intervals}
  //                 onChange={(e) => {
  //                   const value = e.target.value;
  //                   if ((/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 10000) || value === "") {
  //                     handleFieldChange(e);
  //                   }
  //                 }}
  //                 onBlur={(e) => {
  //                   const value = e.target.value;
  //                   if (!value || Number(value) < 1) {
  //                     handleFieldChange({ target: { name: "intervals", value: "1" } });
  //                   }
  //                 }}
  //                 className="w-16 p-0 bg-transparent border-0 text-gray-800 focus:ring-0 dark:text-white"
  //                 placeholder=""
  //                 required
  //                 min={1}
  //               />
  //             </div>
  //             <div className="text-xs">year(s)</div>
  //           </div>
  //           <div className="flex gap-2 py-2 items-center">
  //             <div>
  //               <input
  //                 type="radio"
  //                 name="yearly_option"
  //                 value={"specific_year"}
  //                 className="radio  checked:border-indigo-500 checked:bg-indigo-900 "
  //                 checked={formData?.yearly_option === "specific_year"}
  //                 onChange={handleFieldChange}
  //               />
  //             </div>
  //             <div className="text-xs">On </div>

  //             <select
  //               id={`recurr_pattern_days`}
  //               name="recurr_pattern_days"
  //               // onChange={handleRecurChange}
  //               className={`custom-select bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block  h-9 appearance-none pr-10`}
  //             >
  //               {monthOfYear.map((month, index) => (
  //                 <option key={index} value={month}>
  //                   {month}
  //                 </option>
  //               ))}
  //             </select>

  //             <div className="appearance-none pb-5 px-3 w-20 h-9 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block">
  //               <input
  //                 type="number"
  //                 id="visitors"
  //                 className="w-16  p-0 bg-transparent border-0 text-gray-800 focus:ring-0 dark:text-white"
  //                 placeholder=""
  //                 required
  //                 defaultValue={1}
  //                 min={1}
  //               />
  //             </div>
  //           </div>

  //           <div className="flex gap-2 py-2 items-center">
  //             <div>
  //               <input
  //                 type="radio"
  //                 name="yearly_option"
  //                 value={"weekday_of_year"}
  //                 className="radio  checked:border-indigo-500 checked:bg-indigo-900 "
  //                 checked={formData?.yearly_option === "weekday_of_year"}
  //                 onChange={handleFieldChange}
  //               />
  //             </div>
  //             <div className="text-xs">On The</div>

  //             <div className="flex items-center justify-end">
  //               <select
  //                 id={`recurr_pattern_times`}
  //                 name="recurr_pattern_times"
  //                 // onChange={handleRecurChange}
  //                 className={`custom-select bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block w-full h-9 appearance-none pr-10`}
  //               >
  //                 <option value="First">First</option>
  //                 <option value="Second">Second</option>
  //                 <option value="Third">Third</option>
  //               </select>
  //               <div className="absolute flex px-2 pointer-events-none">
  //                 <h4>
  //                   <i className="bi bi-chevron-down"></i>
  //                 </h4>
  //               </div>
  //             </div>
  //             {/* {formErrors.recurr_pattern && (
  //               <span className="text-red-500 text-xs">
  //                 Cannot be left blank.
  //               </span>
  //             )} */}

  //             <div className="flex items-center justify-end">
  //               <select
  //                 id={`recurr_pattern_days`}
  //                 name="recurr_pattern_days"
  //                 // onChange={handleRecurChange}
  //                 className={`custom-select bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block w-full h-9 appearance-none pr-10`}
  //               >
  //                 {daysOfWeek.map((day, index) => (
  //                   <option key={index} value={day}>
  //                     {day}
  //                   </option>
  //                 ))}
  //               </select>
  //               <div className="absolute flex px-2 pointer-events-none">
  //                 <h4>
  //                   <i className="bi bi-chevron-down"></i>
  //                 </h4>
  //               </div>
  //             </div>
  //             {/* {formErrors.recurr_pattern && (
  //               <span className="text-red-500 text-xs">
  //                 Cannot be left blank.
  //               </span>
  //             )} */}

  //             <div className="text-xs">Of Every</div>

  //             <select
  //               id={`recurr_pattern_days`}
  //               name="recurr_pattern_days"
  //               // onChange={handleRecurChange}
  //               className={`custom-select bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block  h-9 appearance-none pr-10`}
  //             >
  //               {monthOfYear.map((month, index) => (
  //                 <option key={index} value={month}>
  //                   {month}
  //                 </option>
  //               ))}
  //             </select>
  //           </div>
  //         </div>
  //       );
  //     default:
  //       return null;
  //   }
  // };

  const handleSubmit = (e) => {
    e.stopPropagation();
    e.preventDefault();
    console.log(formRef.current, e, "formref");
    handleRecurTask(e);

    // if (formRef.current) {
    //   formRef.current.requestSubmit();
    // }
  };

  const HeaderAction = () => {
    return (
      <button className="bg-primary text-[#FFFFFF] px-3 py-1 rounded-md text-base" onClick={handleRecurTask}>
        Save
      </button>
    );
  };

  const CustomRadio = (props) => (
    <Radio
      sx={{
        "&.Mui-checked": {
          color: "#1D4469", // Checked fill and border
        },
      }}
      {...props}
    />
  );

  return (
    // <div className="fixed inset-0 flex items-center justify-center z-[9999] bg-gray-900 bg-opacity-50">
    <CustomDrawer
      open={open}
      onClose={closePopup}
      anchorParentRef={drawerRef}
      subDrawer={subDrawer}
      headerText="Recurrence"
      headerAction={HeaderAction()}
    >
      {/* <div className="relative mt-18 bg-white   font-popns  rounded-md  overflow-hidden no-scrollbar h-full flex flex-col"> */}
      {false && (
        <div className=" flex items-center justify-between p-1 px-3 md:p-1 md:px-3  border-b border-BECBD3 rounded-t">
          <button onClick={closePopup} style={{ height: "34px" }}>
            {<i className="bi bi-arrow-left mr-2"></i>}{" "}
          </button>
          <h3 className="text-md font-500 text-434852">Appointment Recurrence</h3>
          <button
            onClick={closePopup}
            type="button"
            className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
            data-modal-hide="assets-modal"
          >
            {/* <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg> */}
            <CloseModalImg className="w-3 h-3" />
            <span className="sr-only">Close modal</span>
          </button>
        </div>
      )}

      {/* aakash sir */}
      {false && (
        <form className=" lg:max-h-[85vh]  overflow-hidden  no-scrollbar p-4 px-6 flex-grow min-h-0 flex flex-col justify-between">
          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-6"> */}
          <div>
            <div className="flex items-end gap-2">
              {StartTime}
              {EndTime}
            </div>

            <div calssName="flex-grow">
              <div className=" mb-3">
                <label htmlFor="categories" className="block text-434852">
                  <span className="text-gray-700 text-sm font-medium">Recurrence Pattern</span>
                  <span className=" text-red-500"> *</span>
                </label>
                <div className="flex flex-col">
                  {/* <select
                  id={`frequency`}
                  name="frequency"
                  onChange={handleFieldChange}
                  className={`h-9 custom-select bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block w-full h-9 appearance-none pr-10`}
                >
                  <option value="daily" selected={formData?.frequency === "daily"}>Daily</option>
                  <option value="weekly" selected={formData?.frequency === "weekly"}>Weekly</option>
                  <option value="monthly" selected={formData?.frequency === "monthly"}>Monthly</option>
                  <option value="yearly" selected={formData?.frequency === "yearly"}>Yearly</option>
                </select> */}

                  <FormControl component="fieldset">
                    {/* <FormLabel component="legend">Frequency</FormLabel> */}
                    <RadioGroup
                      row
                      aria-label="frequency"
                      name="frequency"
                      value={formData?.frequency}
                      onChange={handleFieldChange}
                      sx={{ "& .MuiTypography-root": { fontSize: "0.8rem" } }}
                    >
                      <FormControlLabel value="daily" control={<Radio />} label="Daily" />
                      <FormControlLabel value="weekly" control={<Radio />} label="Weekly" />
                      <FormControlLabel value="monthly" control={<Radio />} label="Monthly" />
                      {/*

                        <FormControlLabel
                          value="yearly"
                          control={<Radio />}
                          label="Yearly"
                        />
                        */}
                    </RadioGroup>
                  </FormControl>

                  <RecurrenceSection
                    formData={formData}
                    handleFieldChange={handleFieldChange}
                    daysOfWeek={daysOfWeek}
                    monthOfYear={monthOfYear}
                    toggleDaySelection={toggleDaySelection}
                    handleDayValidation={handleDayValidation}
                  />

                  {/* {<RecurrenceSection />} */}

                  {/* <div className="absolute flex px-2 pointer-events-none pr-5">
                  <h4>
                    <i className="bi bi-chevron-down"></i>
                  </h4>
                </div> */}
                </div>
                {errors?.frequency && <span className="text-red-500 text-xs">{errors?.frequency}</span>}
              </div>

              {/* <div className="mb-3 px-6">
              <label htmlFor="categories" className="block mb-2  text-434852">
                <span className="text-gray-700 text-sm font-medium">
                  Recur Every
                </span>
                <span className=" text-red-500"> *</span>
                {renderRecurrenceSection()}
              </label>
            </div> */}
              {/* </div> */}

              {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-6"> */}
              <div className=" mb-3 grid grid-cols-[35%_65%]">
                <div className="flex items-center self-start">
                  <label htmlFor="duedate" className=" text-434852">
                    <span className="text-gray-700 text-xs font-medium">Start Date:</span>
                    {/* <span className=" text-red-500"> *</span> */}
                  </label>

                  <div className="relative  flex">
                    <DatePicker
                      selected={startDate}
                      onChange={handleStartDateChange}
                      // dateFormat={displayFormat}
                      startDate={startDate}
                      // minDate={new Date()}
                      placeholderText="Start Date"
                      className="h-8 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-full"
                      calendarClassName="absolute right-0 flex justify-end"
                      // popperPlacement=" top-0"
                      dateFormat="dd-MM-yyyy"
                      minDate={new Date()}
                    />

                    <div className="relative inset-y-0 flex items-center pr-3 pointer-events-none bg-zinc-200 px-3 rounded-e text-lg  pb-2">
                      <i className="bi bi-clock w-5 h-5"></i>{" "}
                    </div>
                  </div>
                </div>

                <div className="ms-5 ">
                  {/* <label
                  htmlFor="duedate"
                  className="basis-5/5 block mb-2  text-434852"
                >
                  <span className="text-gray-700 text-sm font-medium">
                    Recurrence End By :
                  </span>
                </label> */}

                  <div className="flex gap-3 items-center">
                    <div>
                      <input
                        type="radio"
                        name="end_by"
                        value={"end_by"}
                        className="radio  checked:border-primary-90 checked:bg-primary "
                        onChange={handleEndByChange}
                        checked={formData?.endBy === "end_by"}
                      />
                    </div>
                    <div className="text-xs"> End By </div>
                    <div className="relative flex">
                      <DatePicker
                        selected={endDate}
                        onChange={handleEndDateChange}
                        endDate={endDate}
                        minDate={startDate}
                        // dateFormat="dd-MM-yyyy"
                        placeholderText="End Date"
                        className={`h-8 ${formData?.endBy === "after" ? "bg-gray-200 opacity-50" : "bg-white"}  rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-[90px]`}
                        disabled={formData?.endBy === "after"}
                        dateFormat="dd-MM-yyyy"
                      />

                      {/* <div className="relative inset-y-0 flex items-center pr-3 pointer-events-none bg-zinc-200 px-3 rounded-e text-lg  pb-2">
                      <i className="bi bi-clock w-5 h-5 "></i>{" "}
                    </div> */}
                    </div>
                  </div>

                  <div className="flex gap-3 py-2 items-center">
                    <div>
                      <input
                        type="radio"
                        name="after"
                        value={"after"}
                        className="radio  checked:border-primary-90 checked:bg-primary"
                        onChange={handleEndByChange}
                        checked={formData?.endBy === "after"}
                      />
                    </div>
                    <div className="text-xs min-w-fit">End After</div>

                    <div className="appearance-none  px-3  bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-20">
                      <input
                        type="number"
                        id="occurrences"
                        name="occurrences"
                        value={formData?.occurrences}
                        onChange={handleFieldChange}
                        className="w-16 p-0 bg-transparent border-0 text-gray-800 focus:ring-0 dark:text-white"
                        placeholder=""
                        required
                        disabled={formData?.endBy === "end_by"}
                        min={1}
                      />
                    </div>
                  </div>

                  <div className="flex gap-3 py-2 items-center">
                    <div>
                      <input
                        type="radio"
                        name="after"
                        value={"after"}
                        className="radio  checked:border-primary-90 checked:bg-primary"
                        onChange={handleEndByChange}
                        checked={formData?.endBy === "after"}
                      />
                    </div>
                    <div className="text-xs min-w-fit">End After</div>

                    <div>
                      <input
                        type="number"
                        id="intervals"
                        name="intervals"
                        value={formData?.intervals}
                        onChange={(e) => {
                          const value = e.target.value;
                          if ((/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 10000) || value === "") {
                            handleFieldChange(e);
                          }
                        }}
                        onBlur={(e) => {
                          const value = e.target.value;
                          if (!value || Number(value) < 1) {
                            handleFieldChange({ target: { name: "intervals", value: "1" } });
                          }
                        }}
                        className={`p-1  bg-transparent border-0 text-gray-800 focus:ring-0 dark:text-white disabled:opacity-50 disabled:bg-[#EBEBE4]`}
                        placeholder=""
                        required
                        disabled={formData?.daily_option === "every_weekday"}
                      />
                    </div>

                    <div className="text-xs">Occurrences</div>
                  </div>

                  {/* <div className="flex gap-3  items-center ">
                    <div>
                      <input
                        type="radio"
                        name="no_end_date"
                        value={"no_end_date"}
                        className="radio  checked:border-indigo-500 checked:bg-indigo-900"
                        onChange={handleEndByChange}
                        checked={formData?.endBy === "no_end_date"}
                      />
                    </div>
                    <div className="text-xs">No End Date</div>
                  </div> */}
                  {/* <i className="bi bi-calendar2-event absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none cursor:pointer"></i> */}
                </div>
              </div>
            </div>
          </div>
          <div className="sticky bottom-0 flex justify-end py-4 text-lg w-full rounded-none">
            <div className="">
              <button
                onClick={closePopup}
                type="button"
                className="  h-9 text-535252 bg-F4F4F4 hover:bg-eeeeee cancel-btn focus:ring-4 focus:ring-blue-300 font-semibold px-5 py-1.2 text-center rounded-[5px]"
              >
                CANCEL
              </button>
              <button
                type="button"
                onClick={handleRecurTask}
                className="btn-submit h-9 w-28 text-white bg-1D4469 hover:bg-20486F save-btn font-semibold text-gray-900 border border-gray-200 py-1.3 px-5 ms-3 rounded-[5px]"
              >
                SET
              </button>
            </div>
          </div>
        </form>
      )}

      {/* vinay */}
      <form
        className="h-full overflow-hidden  no-scrollbar py-4 flex-grow min-h-0 flex flex-col justify-between bg-[#FFF] rounded-md border border-[#BECBD3] px-4"
        ref={formRef}
      >
        <div className="flex items-start flex-col min-h-0 grow">
          {/* <div className="flex items-start flex-col justify-start w-full border-b border-[#BECBD3] pb-2 ">
            <span className="text-[#434852] text-base font-poppins font-500 break-words">Set/Appointment Time</span>
            <div className="flex items-end gap-2 w-full">
              {StartTime}
              {EndTime}
            </div>
          </div> */}

          <div className="flex items-start flex-col justify-start w-full py-2">
            <label htmlFor="categories" className="block mb-2  text-434852">
              <span className="text-[#434852] text-base font-poppins font-500 break-words">Recurrence Pattern</span>
              <span className=" text-red-500"> *</span>
            </label>
            <div className="flex flex-col bg-[#f3f5f7] rounded-md border border-[#BECBD3] px-2 w-full">
              <FormControl component="fieldset">
                {/* <FormLabel component="legend">Frequency</FormLabel> */}
                <RadioGroup
                  row
                  aria-label="frequency"
                  name="frequency"
                  value={formData?.frequency}
                  onChange={handleFieldChange}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "nowrap",
                    "& .MuiTypography-root": { fontSize: "0.8rem", color: "#434852;", fontWeight: 400 },
                  }}
                >
                  <FormControlLabel value="daily" control={<CustomRadio />} label="Daily" />
                  <FormControlLabel value="weekly" control={<CustomRadio />} label="Weekly" />
                  <FormControlLabel value="monthly" control={<CustomRadio />} label="Monthly" />
                  {/*

                        <FormControlLabel
                          value="yearly"
                          control={<Radio />}
                          label="Yearly"
                        />
                        */}
                </RadioGroup>
              </FormControl>
            </div>
            {errors?.frequency && <span className="text-red-500 text-xs">{errors?.frequency}</span>}
          </div>

          <div className="w-full flex items-center justify-start border-b border-[#BECBD3] pb-2">
            <div className="">
              {
                <RecurrenceSection
                  formData={formData}
                  handleFieldChange={handleFieldChange}
                  daysOfWeek={daysOfWeek}
                  monthOfYear={monthOfYear}
                  toggleDaySelection={toggleDaySelection}
                  handleDayValidation={handleDayValidation}
                />
              }
            </div>
          </div>

          <div className="w-full flex flex-col gap-1 py-4">
            <p className="text-[#434852] text-base font-poppins font-500 break-words">Range of Recurrence</p>
            <div className="w-full gap-2 flex flex-col items-start justify-between ">
              <div className="flex gap-4 items-centre justify-start w-fit grow min-w-0">
                <span className="flex items-center justify-start mr-2">
                  <label className="text-[#434858] text-sm text-nowrap">Start Date</label>
                </span>

                <div className="relative flex w-fit">
                  <DatePicker
                    selected={startDate}
                    onChange={handleStartDateChange}
                    placeholderText="Start Date"
                    startDate={startDate}
                    dateFormat="dd-MM-yyyy"
                    className="h-8 bg-white  rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-[105px]"
                    minDate={new Date()}
                  />
                  <div className="absolute right-0 top-0 flex items-center pointer-events-none">
                    <CalendarIcon className="h-[28px] w-[29px]" />
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-[auto_auto] gap-2 items-center mr-2  grow min-w-0">
                {/* First Row: "End By" Radio Button and DatePicker */}
                <div className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="end_by"
                    value={"end_by"}
                    onChange={handleEndByChange}
                    className="radio checked:border-primary-90 checked:bg-primary"
                    placeholder=""
                    required
                    // disabled={formData?.endBy === "end_by"}
                    checked={formData?.endBy === "end_by"}
                  />
                  <div className="text-sm text-[#434852]">End By</div>
                </div>

                <div className="relative w-fit flex justify-start ">
                  <DatePicker
                    selected={endDate}
                    onChange={handleEndDateChange}
                    endDate={endDate}
                    minDate={startDate}
                    placeholderText="End Date"
                    className="h-8 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B active:border active:border-DFE2E5 text-gray-900 text-xs block w-[105px]"
                    disabled={formData?.endBy === "after"}
                    dateFormat="dd-MM-yyyy"
                  />
                  <div className="absolute right-0 top-0 flex items-center pointer-events-none">
                    <CalendarIcon className="h-[28px] w-[29px]" />
                  </div>
                </div>

                {/* Second Row: "End After" Radio Button and DatePicker */}
                <div className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="after"
                    value={"after"}
                    className="radio checked:border-primary-90 checked:bg-primary ring-0 focus:ring-0 focus:outline-none"
                    onChange={handleEndByChange}
                    checked={formData?.endBy === "after"}
                  />
                  <div className="text-sm min-w-fit">End After</div>
                </div>

                <div className="flex justify-start items-center gap-1">
                  <input
                    type="number"
                    id="occurrences"
                    name="occurrences"
                    value={formData?.occurrences}
                    onChange={handleFieldChange}
                    // onChange={(e) => {
                    //   const value = e.target.value;
                    //   if ((/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 10000) || value === "") {
                    //     handleFieldChange(e);
                    //   }
                    // }}
                    // onBlur={(e) => {
                    //   const value = e.target.value;
                    //   if (!value || Number(value) < 1) {
                    //     handleFieldChange({ target: { name: "intervals", value: "1" } });
                    //   }
                    // }}
                    className={`w-14 px-2 bg-transparent border-1 border-gray-300 rounded-md text-gray-800 focus:ring-0 dark:text-white disabled:opacity-50 ${formData?.endBy === "end_by"}:bg-[#ebe5e4] ${hideArrowClass}`}
                    placeholder=""
                    required
                    disabled={formData?.endBy === "end_by"}
                    min={1}
                    autoFocus
                  />
                  <div className="text-sm pl-[2px]">Occurrences</div>
                </div>

                {/* Third Row: "No End Data" Radio Button */}
                {/* <div className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="NoData"
                    value={"NoData"}
                    className="radio checked:border-indigo-500 checked:bg-indigo-900"
                    onChange={handleEndByChange}
                    checked={formData?.NoData === "NoData"}
                  />
                  <div className="text-xs min-w-fit">No End Data</div>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        {/* <div className="sticky bottom-0 flex justify-end py-4 px-3 text-lg w-full rounded-none">
          <div className="">
            <button
              onClick={closePopup}
              type="button"
              className="  h-9 text-535252 bg-F4F4F4 hover:bg-eeeeee cancel-btn focus:ring-4 focus:ring-blue-300 font-semibold px-5 py-1.2 text-center rounded-[5px]"
            >
              CANCEL
            </button>
            <button
              type="button"
              onClick={handleRecurTask}
              className="btn-submit h-9 w-28 text-white bg-1D4469 hover:bg-20486F save-btn font-semibold text-gray-900 border border-gray-200 py-1.3 px-5 ms-3 rounded-[5px]"
            >
              SET
            </button>
          </div>
        </div> */}
      </form>
      {/* </div> */}
    </CustomDrawer>
    // </div>
  );
};

export default RecurrenceModal;
